<template>
  <div>
    <div class="schedule-row mt-16" v-for="day in day_names" :key="day">
      <div class="schedule-day" @click="onToggleDay(day)">
        <BaseCheckbox :value="value[day].workday" />
        <span
          class="qrw-heading-xs"
          :class="{
            'day-off': !value[day].workday,
            'workday-dark': dark && value[day].workday,
          }"
        >
          {{ $t(`schedule.days.${day}`) }}
        </span>
      </div>
      <div class="schedule-selects">
        <BaseSelect
          @blur="save"
          :style="!value[day].workday ? disabledSelectStyle : ''"
          :disabled="!value[day].workday || !editing"
          v-model.number="value[day].startHour"
          :invalid="invalid && value[day].startHour === null"
          class="schedule-select"
          :class="{ dark }"
        >
          <option :value="null" disabled v-if="value[day].startHour === null">
            -
          </option>
          <option v-for="h in 25" :value="h - 1" :key="h">
            {{ formatTime(h - 1) }}
          </option>
        </BaseSelect>
        <BaseSelect
          @blur="save"
          :style="!value[day].workday ? disabledSelectStyle : ''"
          :disabled="!value[day].workday || !editing"
          v-model.number="value[day].startMinute"
          :invalid="invalid && value[day].startMinute === null"
          class="schedule-select ml-4"
          :class="{ dark }"
        >
          <option :value="null" disabled v-if="value[day].startMinute === null">
            -
          </option>
          <option v-for="m in 60" :value="m - 1" :key="m">
            {{ formatTime(m - 1) }}
          </option>
        </BaseSelect>

        <BaseSelect
          @blur="save"
          :style="!value[day].workday ? disabledSelectStyle : ''"
          :disabled="!value[day].workday || !editing"
          v-model.number="value[day].endHour"
          :invalid="invalid && value[day].endHour === null"
          class="schedule-select ml-16"
          :class="{ dark }"
        >
          <option :value="null" disabled v-if="value[day].endHour === null">
            -
          </option>
          <option v-for="h in 25" :value="h - 1" :key="h">
            {{ formatTime(h - 1) }}
          </option>
        </BaseSelect>

        <BaseSelect
          @blur="save"
          :style="!value[day].workday ? disabledSelectStyle : ''"
          :disabled="!value[day].workday || !editing"
          v-model.number="value[day].endMinute"
          :invalid="invalid && value[day].endMinute === null"
          class="schedule-select ml-4"
          :class="{ dark }"
        >
          <option :value="null" disabled v-if="value[day].endMinute === null">
            -
          </option>
          <option v-for="m in 60" :value="m - 1" :key="m">
            {{ formatTime(m - 1) }}
          </option>
        </BaseSelect>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      day_names: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"],
    };
  },
  props: {
    value: Object,
    dark: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false
    },
    editing: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onToggleDay(day) {
      if (!this.editing) return;
      this.value[day].workday = !this.value[day].workday;
      this.save();
    },
    save() {
      this.$emit("input", this.value);
    },
    formatTime(raw) {
      return `${raw}`.padStart(2, "0");
    },
  },
  computed: {
    disabledSelectStyle() {
      if (!this.dark) return {};

      return {
        color: "var(--v1-grey-6-color)",
        background: "var(--v1-grey-9-color)",
      };
    }
  },
};
</script>

<style scoped>
.schedule-row {
  display: flex;
  align-items: center;
  align-self: center;
  align-content: center;

  justify-content: space-between;
  width: 100%;
}

.schedule-select {
  width: 80px;
  max-width: 80px;
  min-width: 80px;
}

.schedule-selects {
  width: 100%;
  display: flex;
}

.schedule-day {
  display: flex;
  width: 100%;
  cursor: pointer;

  column-gap: 8px;
  flex-direction: row;
}

.day-off {
  color: var(--v1-grey-6-color);
}

.workday-dark {
  color: var(--v1-grey-2-color);
}
</style>

<style>
.schedule-select.dark select:disabled {
  color: var(--v1-grey-2-color) !important;
  background: transparent;
}
</style>
